export default __webpack_public_path__ + "static/media/t1.960f8312.png";